import { isMuted, setMuted } from "../audio.ts";
import { ui } from "../engine.ts";
import { btn, h } from "../ui/dom.ts";

/** Sound toggle. `centered` keeps it clear of the battle HUD panels. */
export function muteButton(centered = false): HTMLElement {
  const b = btn(isMuted() ? "🔇" : "🔊", () => {
    setMuted(!isMuted());
    b.textContent = isMuted() ? "🔇" : "🔊";
  }, "small wood icon-btn", { title: "Toggle sound" });
  return h("div", { class: `corner${centered ? " center" : ""}` }, b);
}

export function showHelp(): void {
  const close = () => overlay.remove();
  const overlay = h(
    "div",
    { class: "chapter-card", style: { display: "block" }, onclick: (e: Event) => e.target === overlay && close() },
    h(
      "div",
      { class: "help panel" },
      h("h2", null, "How to Fight"),
      h(
        "ul",
        null,
        h("li", null, "Fights are turn-based: you act, then your foe acts."),
        h("li", null, h("b", null, "Advance / Retreat"), " to control distance. Most weapons need you beak-to-beak; spears, forks and scythes ", h("b", null, "reach 2"), "."),
        h("li", null, h("b", null, "Quick Peck"), " is accurate but weak. ", h("b", null, "Strike"), " is balanced. ", h("b", null, "Mighty Wallop"), " hits hardest but misses more and burns energy."),
        h("li", null, h("b", null, "Taunt"), " pits your Charisma against theirs: drains their energy, rattles their aim, and whips up the crowd."),
        h("li", null, h("b", null, "Rest"), " recovers energy (and a little health). Every action except resting also regains 3 energy."),
        h("li", null, "Fill the ", h("b", null, "crowd meter"), " with hits and taunts. A roaring crowd adds 15% damage and pays a bigger purse."),
        h("li", null, h("b", null, "Fowl Arts"), " (Egg Grenade, Rooster Roar, Feather Frenzy, Second Wind) are learned by conquering regions."),
        h("li", null, "Lose and you're patched up for free, keeping a little XP. Exhibition matches earn extra gold and XP."),
      ),
      h("h3", null, "Stats"),
      h(
        "ul",
        null,
        h("li", null, h("b", null, "STR"), " damage · ", h("b", null, "ATK"), " hit chance · ", h("b", null, "DEF"), " dodge and shield blocks · ", h("b", null, "AGI"), " dodge and movement"),
        h("li", null, h("b", null, "VIT"), " health · ", h("b", null, "STA"), " energy · ", h("b", null, "CHA"), " taunts, crits and purse"),
      ),
      h("h3", null, "Keyboard"),
      h("p", null, "← → move · 1 2 3 attacks · T taunt · R rest · 4–7 Fowl Arts · Space/Enter advances dialogue"),
      h("div", { class: "row", style: { justifyContent: "center", marginTop: "10px" } }, btn("Got it!", close, "green")),
    ),
  );
  ui.append(overlay);
}
